/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Tripwire
 */
export interface Tripwire {
  /**
   *
   * @type {string}
   * @memberof Tripwire
   */
  tripwireId?: string;
  /**
   *
   * @type {string}
   * @memberof Tripwire
   */
  tripwireName?: string;
  /**
   *
   * @type {number}
   * @memberof Tripwire
   */
  consecutiveFailures?: number;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Tripwire
   */
  trippedAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof Tripwire
   */
  trippedReason?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Tripwire
   */
  lastFailureAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof Tripwire
   */
  lastFailureMessage?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Tripwire
   */
  lastSuccessAt?: OffsetDateTime;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Tripwire
   */
  resetAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof Tripwire
   */
  resetBy?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Tripwire
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Tripwire
   */
  updatedAt?: OffsetDateTime;
}

/**
 * Check if a given object implements the Tripwire interface.
 */
export function instanceOfTripwire(value: object): value is Tripwire {
  return true;
}

export function TripwireFromJSON(json: any): Tripwire {
  return TripwireFromJSONTyped(json, false);
}

export function TripwireFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Tripwire {
  if (json == null) {
    return json;
  }
  return {
    tripwireId: json["tripwireId"] == null ? undefined : json["tripwireId"],
    tripwireName:
      json["tripwireName"] == null ? undefined : json["tripwireName"],
    consecutiveFailures:
      json["consecutiveFailures"] == null
        ? undefined
        : json["consecutiveFailures"],
    trippedAt: json["trippedAt"] == null ? undefined : json["trippedAt"],
    trippedReason:
      json["trippedReason"] == null ? undefined : json["trippedReason"],
    lastFailureAt:
      json["lastFailureAt"] == null ? undefined : json["lastFailureAt"],
    lastFailureMessage:
      json["lastFailureMessage"] == null
        ? undefined
        : json["lastFailureMessage"],
    lastSuccessAt:
      json["lastSuccessAt"] == null ? undefined : json["lastSuccessAt"],
    resetAt: json["resetAt"] == null ? undefined : json["resetAt"],
    resetBy: json["resetBy"] == null ? undefined : json["resetBy"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    updatedAt: json["updatedAt"] == null ? undefined : json["updatedAt"],
  };
}

export function TripwireToJSON(json: any): Tripwire {
  return TripwireToJSONTyped(json, false);
}

export function TripwireToJSONTyped(
  value?: Tripwire | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    tripwireId: value["tripwireId"],
    tripwireName: value["tripwireName"],
    consecutiveFailures: value["consecutiveFailures"],
    trippedAt: value["trippedAt"],
    trippedReason: value["trippedReason"],
    lastFailureAt: value["lastFailureAt"],
    lastFailureMessage: value["lastFailureMessage"],
    lastSuccessAt: value["lastSuccessAt"],
    resetAt: value["resetAt"],
    resetBy: value["resetBy"],
    createdAt: value["createdAt"],
    updatedAt: value["updatedAt"],
  };
}
